import { render, staticRenderFns } from "./Ligar.vue?vue&type=template&id=3444e95e"
import script from "./Ligar.vue?vue&type=script&lang=js"
export * from "./Ligar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports